import {jarallax} from 'jarallax';
$( document ).ready(function() {
  jarallax(document.querySelectorAll('.jarallax'));
});
export default {
  init() {

  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/util/Jarallax.js